import styles from './styles.module.css';

type LabelProps = {
  children: React.ReactNode;
  fontSize?: number;
  color?: string;
  htmlFor?: string;
  disabled?: boolean;
  className?: string;
  style?: any;
  width?: string;
};

const Label: React.FunctionComponent<LabelProps> = (props: LabelProps) => {
  return (
    <label
      className={styles.label}
      {...props}
      style={{ color: props.color, fontSize: props.fontSize, width: props?.width || 'initial' }}
    >
      {props.children}
    </label>
  );
};

export default Label;
